/*eslint-disable*/
import React from "react";
import classNames from "classnames";
import { makeStyles } from "@material-ui/core/styles";
import Header from "components/Header/Header.js";
import Footer from "components/Footer/Footer.js";
import Button from "components/CustomButtons/Button.js";
import HeaderLinks from "components/Header/HeaderLinks.js";
import styles from "assets/jss/material-kit-react/views/staticPages.js";
import Parallax from "components/Parallax/Parallax";
import { language } from "config";

const dashboardRoutes = [];

const useStyles = makeStyles(styles);

export default function AboutUs(props) {
  const classes = useStyles();
  const { ...rest } = props;

  return (
    <div>
      <Header
        color="transparent"
        routes={dashboardRoutes}
        rightLinks={<HeaderLinks />}
        fixed
        changeColorOnScroll={{
          height: 400,
          color: "white",
        }}
        {...rest}
      />
      <Parallax
        small
        filter
        image={require("assets/api_images/5-load-page-image-transparent_fullpage-blue-redline-top.png")}
      />
      <div className={classNames(classes.main, classes.mainRaised)}>
        <div className={classes.container}>
          <br />
          <h2 className={classes.title}>{language.about_us}</h2>
          <p className={classes.description}>
            API Property Group specialises in industrial and commercial property
            throughout Johannesburg, Pretoria, Durban and Cape Town. We pride
            ourselves in being experts within the industry and highly
            knowledgeable of the areas we operate in. We focus on leasing,
            selling and/or purchasing of industrial and commercial property. Our
            professional brokers are eager to assist with all enquiries. We
            provide a turnkey solution to clients in respect of their industrial
            property needs. Our brokers will best endeavour to fulfil your
            industrial property requirements.
          </p>
          {/* <p className={classes.description}>{language.about_us_content2}</p> */}
          <br />
          <div>
            <Button
              simple
              color="primary"
              size="lg"
              // onClick={LogOut}
              href="https://www.apiproperty.co.za/profile/"
            >
              {language.about_but}
            </Button>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}
